import { Star } from 'lucide-react';

const testimonials = [
  {
    quote:
      "I can't thank Moreflex Aviation enough for their exceptional service. The meet and greet service was flawless, and the chauffeur was professional and punctual. Will definitely use their services again!",
    name: 'Mr. Fadil Mohammed',
    role: 'Frequent Traveler',
    image:
      'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1473&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
  },
  {
    quote:
      'The lounge access provided by Moreflex Aviation made my layover so much more comfortable. The staff was attentive and the baggage assistance saved me so much time and stress. Highly recommended!',
    name: 'Daniel Amuyunzu.',
    role: 'Business Executive',
    image:
      'https://images.unsplash.com/photo-1598760122223-45f0f18a1bbd?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80',
  },
  {
    quote:
      'As someone who travels frequently for business, Moreflex Aviation has become an essential part of my travel routine. Their fleet services are top-notch and their staff is always professional and courteous.',
    name: 'Mr. Hughe Evans',
    role: 'Corporate Traveler',
    image:
      'https://images.unsplash.com/photo-1520262494112-9fe481d36ec3?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=761&q=80',
  },
];

function TestimonialsSection() {
  return (
    <section className="relative py-20 md:py-24 bg-gradient-to-br from-black via-[#0b1f33] to-[#1a3c55] overflow-hidden">
      <div className="hero-pattern absolute inset-0" />
      <div className="container relative mx-auto px-4">
        <div className="text-center mb-16 text-white max-w-2xl mx-auto">
          <p className="eyebrow justify-center mb-3">Testimonials</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold">
            What Our Satisfied Client Saying In
            <br />
            Their Feedback!
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.name}
              className={`bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 text-white animate-fadeIn ${
                index === 1 ? 'delay-100' : index === 2 ? 'delay-200' : ''
              }`}
            >
              <div className="flex mb-4 text-yellow-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <p className="mb-6 text-white/80">"{testimonial.quote}"</p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white rounded-full overflow-hidden mr-4 ring-2 ring-[#73BDF2]/40">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} ${testimonial.role}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h4 className="font-heading font-bold">{testimonial.name}</h4>
                  <p className="text-sm text-white/60">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
